import classnames from 'classnames'

import Box from '~/core/Box'
import Tooltip from '~/core/Tooltip'
import Image from '~/core/Image'
import Text from '~/core/Text'
import styles from '~/apps/consumer/components/PartViewerModal/styles.css'
import {
    HEADER_STYLES,
    ATTACHMENT_FILE_TYPE,
} from '~/apps/consumer/components/PartViewerModal/logic'
import { CertificateType } from '~/apps/consumer/components/PartViewerModal/types'
import PDFThumbnail from '~/apps/consumer/components/PartViewerModal/components/PartDetails/components/InspectionReport/DimensionalInspection/PDFThumbnail'

export default function Certificate(props: CertificateType) {
    const {
        certificates,
        selectedInspectionDocument,
        setInspectionDocumentIdx,
        numPrevItems,
    } = props

    const partPhotosOnly = certificates.filter(item =>
        item?.mimeType?.includes(ATTACHMENT_FILE_TYPE.IMAGE),
    )
    const selectedInspectionDocumentUrl: string | null =
        selectedInspectionDocument >= numPrevItems
            ? partPhotosOnly[selectedInspectionDocument - numPrevItems]
                  ?.downloadUrl
            : null

    return (
        <>
            <Text style={HEADER_STYLES}>Certificates</Text>
            <Box
                direction="row"
                className={styles.wrapperForPhotoAndDocumentTiles}
            >
                {certificates.map(item => {
                    const isSelected =
                        item.downloadUrl === selectedInspectionDocumentUrl

                    return item?.mimeType?.includes(
                        ATTACHMENT_FILE_TYPE.IMAGE,
                    ) ? (
                        <Tooltip title={item.fileName} key={item.createdAt}>
                            <Box
                                onClick={() =>
                                    setInspectionDocumentIdx(
                                        partPhotosOnly.findIndex(
                                            photo =>
                                                photo.downloadUrl ===
                                                item.downloadUrl,
                                        ) + numPrevItems,
                                    )
                                }
                            >
                                <Image
                                    className={classnames(
                                        styles.inspectionThumbnail,
                                        isSelected &&
                                            styles.inspectionThumbnailSelected,
                                    )}
                                    src={item.downloadUrl}
                                />
                            </Box>
                        </Tooltip>
                    ) : (
                        <PDFThumbnail key={item.createdAt} file={item} />
                    )
                })}
            </Box>
        </>
    )
}
